
















































































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import {
  DrivewealthAccountSummary, DrivewealthAccountManagementType
} from "@/shared/types";
import { Location } from "vue-router";
import { formatCurrency } from "@/shared/currency";
import _ from "lodash";
import moment from "moment";
import * as SharedRoutes from "@/shared/route-names";
import * as RouteNames from "@/employee/route-names";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import InvestmentAccountTypeFeeDetails from "@/shared/components/investments/drivewealth/InvestmentAccountTypeFeeDetails.vue";
import InvestmentFeeDisclaimer from "@/employee/components/investments/drivewealth/InvestmentFeeDisclaimer.vue";
import AccountTypeSubheader from "@/employee/components/investments/drivewealth/AccountTypeSubheader.vue";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useEnrollmentStore } from "@/employee/store/enrollment";
import { useInvestmentThresholdStore } from "@/shared/store/investmentThreshold";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

@Component({
  components: {
    GenericLoadingSpinner,
    InvestmentAccountTypeFeeDetails,
    InvestmentFeeDisclaimer,
    AccountTypeSubheader
  }
})
export default class MultipleAccountSelection extends Vue {
  drivewealthStore = useDrivewealthStore();
  enrollmentStore = useEnrollmentStore();
  investmentThresholdStore = useInvestmentThresholdStore();
  custodianSettingsStore = useCustodianSettingsStore();

  SharedRoutes = SharedRoutes;
  formatCurrency = formatCurrency;

  DrivewealthAccountManagementType = DrivewealthAccountManagementType;

  mounted (): void {
    this.enrollmentStore.loadFees();
    this.investmentThresholdStore.loadInvestmentThresholds({});
    this.drivewealthStore.loadAccountSummariesV2({force: true});
  }

  get isLoaded (): boolean {
    return this.drivewealthStore.accountSummariesV2Loaded && this.enrollmentStore.feeScheduleLoaded;
  }

  get formattedDateNow (): string {
    return moment().format("MMM DD");
  }

  get advisoryAccount (): DrivewealthAccountSummary {
    const account = _.find(this.drivewealthStore.accountSummariesV2,
      x => x.accountManagementType === DrivewealthAccountManagementType.Advisory);

    return account;
  }

  get hasAdvisoryAccount (): boolean {
    return this.advisoryAccount !== undefined;
  }

  get openBrokerageAccount (): DrivewealthAccountSummary {
    const account = _.find(this.drivewealthStore.accountSummariesV2,
      x => x.accountManagementType === DrivewealthAccountManagementType.OpenBrokerage);

    return account;
  }

  get hasOpenBrokerageAccount (): boolean {
    return this.openBrokerageAccount !== undefined;
  }

  get managedAccount (): DrivewealthAccountSummary {
    const account = _.find(this.drivewealthStore.accountSummariesV2,
      x => x.accountManagementType === DrivewealthAccountManagementType.RiaManaged);

    return account;
  }

  get hasManagedAccount (): boolean {
    return this.managedAccount !== undefined;
  }

  get learnMoreLocation (): Location {
    return {
      name: RouteNames.DrivewealthLearnMorePages,
      params: {
        subpage: "list"
      }
    };
  }
}
